var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-switch',{attrs:{"disabled":_vm.isStatus,"active-color":"#66b1ff","inactive-color":"#DCDFE6"},on:{"change":_vm.onChange},model:{value:(_vm.checkedS),callback:function ($$v) {_vm.checkedS=$$v},expression:"checkedS"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }